export const UserCommentDOMValue = (
  sessionId: string,
  posInfoStyling: string,
) => {
  return `
<!DOCTYPE html>

<html>
  <head>
    <link rel="preconnect" href="https://fonts.googleapis.com" />
    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
    <link
      href="https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&display=swap"
      rel="stylesheet"
    />

    <style>
      #_recapt-user-comments-parent *:not(svg):not(path):not(rect):not(circle):not(polyline) {
        all: unset;
        font-family: "Lato", sans-serif;
        font-weight: 400;
        font-style: normal;
        box-sizing: border-box;
      }

      #_recapt-user-comments-parent {
        position: fixed;
        ${posInfoStyling}
        border-radius: 1000px;
        z-index: 999999999999999999999999999999999999999999999;
      }

      #_recapt-user-comments-parent #_recapt-circle {
        width: 34px;
        height: 34px;
        background-color: #fdfdfd;
        border: 1px solid #eaeaec;
        padding: 4px;
        border-radius: 1000px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        box-shadow: 0px 10px 15px -3px rgba(0, 0, 0, 0.1);
      }

      #_recapt-user-comments-parent #_recapt-content {
        width: 420px;
        background-color: #ffffff;
        border: 1px solid #e4e4e8;
        position: absolute;
        bottom: 44px;
        right: 0;
        border-radius: 16px;
        padding: 0;
        box-shadow: 0px 12px 32px rgba(0, 0, 0, 0.12);
        flex-direction: column;
        display: none;
        pointer-events: none;
        overflow: hidden;
      }

      #_recapt-content ._recapt-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 16px 20px;
      }

      #_recapt-content ._recapt-header-left {
        display: flex;
        align-items: center;
        gap: 10px;
      }

      #_recapt-content ._recapt-live-dot {
        width: 10px;
        height: 10px;
        background-color: #8C52FF;
        border-radius: 50%;
        display: block;
      }


      #_recapt-content ._recapt-title {
        color: #1a1b2e;
        font-size: 16px;
        font-weight: 700;
        display: block;
      }

      #_recapt-user-comments-parent #_recapt-content #_recapt-close {
        color: #9a9aae;
        font-size: 20px;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 28px;
        height: 28px;
        border-radius: 6px;
        background: none;
        border: none;
        padding: 0;
        margin: 0;
        line-height: 1;
      }

      #_recapt-user-comments-parent #_recapt-content #_recapt-close:hover {
        color: #1a1b2e;
        background-color: rgba(0, 0, 0, 0.05);
      }

      #_recapt-content ._recapt-divider {
        height: 1px;
        background-color: #e4e4e8;
        margin: 0 20px;
        display: block;
      }

      #_recapt-content ._recapt-session-section {
        padding: 16px 20px;
        display: flex;
        flex-direction: column;
        gap: 10px;
      }

      #_recapt-content ._recapt-session-row {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
      }

      #_recapt-content ._recapt-session-info {
        display: flex;
        flex-direction: column;
        gap: 4px;
      }

      #_recapt-content ._recapt-label {
        color: #8a8a9e;
        font-size: 11px;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        display: block;
      }

      #_recapt-content ._recapt-session-id {
        color: #1a1b2e;
        font-size: 15px;
        font-family: "Courier New", monospace;
        font-weight: 600;
        display: block;
      }

      #_recapt-content ._recapt-copy-btn {
        display: flex;
        align-items: center;
        gap: 6px;
        color: #5a5b70;
        font-size: 13px;
        padding: 7px 14px;
        border: 1px solid #d8d8e0;
        border-radius: 8px;
        cursor: pointer;
        background-color: transparent;
      }

      #_recapt-content ._recapt-copy-btn:hover {
        background-color: rgba(0, 0, 0, 0.04);
        border-color: #c0c0cc;
      }

      #_recapt-content ._recapt-form-section {
        padding: 16px 20px;
        display: block;
      }

      #_recapt-user-comments-parent #_recapt-content form {
        display: grid;
        grid-template-columns: 1fr auto;
        gap: 10px;
        align-items: end;
      }

      #_recapt-user-comments-parent #_recapt-content textarea {
        grid-column: 1;
        grid-row: 1;
        resize: none;
        border-radius: 10px;
        border: 1px solid #d8d8e0;
        background-color: #f5f5f8;
        color: #1a1b2e;
        font-size: 14px;
        min-height: 42px;
        max-height: 160px;
        height: 42px;
        padding: 10px 14px;
        line-height: 20px;
        overflow-x: hidden;
        overflow-y: hidden;
        white-space: pre-wrap;
        word-wrap: break-word;
        width: 100%;
      }

      #_recapt-user-comments-parent #_recapt-content textarea::placeholder {
        color: #a0a0b0;
        font-size: 14px;
      }

      #_recapt-user-comments-parent #_recapt-content textarea:focus {
        outline: none;
        border-color: #8C52FF;
      }

      #_recapt-user-comments-parent #_recapt-content textarea::-webkit-scrollbar {
        width: 4px;
      }

      #_recapt-user-comments-parent #_recapt-content textarea::-webkit-scrollbar-track {
        background: transparent;
      }

      #_recapt-user-comments-parent #_recapt-content textarea::-webkit-scrollbar-thumb {
        background-color: #d0d0d8;
        border-radius: 4px;
      }

      #_recapt-user-comments-parent #_recapt-content textarea::-webkit-scrollbar-thumb:hover {
        background-color: #b0b0bc;
      }

      #_recapt-user-comments-parent #_recapt-content textarea {
        scrollbar-width: thin;
        scrollbar-color: #d0d0d8 transparent;
      }

      #_recapt-content ._recapt-send-btn {
        grid-column: 2;
        grid-row: 1;
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background-color: #8C52FF;
        border: none;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 0;
      }

      #_recapt-content ._recapt-send-btn:hover {
        background-color:rgb(110, 64, 200);
      }

      #_recapt-content ._recapt-helper {
        grid-column: 1 / -1;
        grid-row: 2;
        color: #9a9aae;
        font-size: 11px;
        display: block;
      }
    </style>
  </head>
  <body style="background-color: transparent">
    <div id="_recapt-user-comments-container">
      <div id="_recapt-user-comments-parent">
        <div id="_recapt-circle">
          <div style="width: 18px; height: 18px">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 156 156"
              fill="none"
            >
              <path
                d="M25.9684 133.524L53.0203 84.9571C53.5578 83.9922 53.2112 82.7742 52.2463 82.2367L3.53244 55.1031C2.56747 54.5656 2.22092 53.3476 2.75841 52.3827L10.9978 37.5902C11.5353 36.6252 12.7532 36.2787 13.7182 36.8162L76.372 71.7143C80.2319 73.8643 81.6181 78.7362 79.4681 82.5961L63.6938 110.916L45.1501 144.208C44.6126 145.173 43.3946 145.52 42.4296 144.983L26.7424 136.245C25.7775 135.707 25.4309 134.489 25.9684 133.524Z"
                fill="#8C52FF"
                stroke="#8C52FF"
              />
              <path
                d="M84.7901 111.294L94.2935 94.0518C95.0389 92.6995 96.9705 92.6661 97.7622 93.9918L121.275 133.362C121.841 134.31 121.531 135.538 120.583 136.104L105.988 144.821C105.039 145.387 103.811 145.077 103.245 144.129L84.8246 113.285C84.4601 112.675 84.447 111.917 84.7901 111.294Z"
                fill="#A279FF"
                stroke="#A279FF"
              />
              <path
                d="M94.7894 64.2161C98.8444 69.2429 99.7353 72.4965 98.4805 79.3377C98.2111 80.8069 99.5258 82.1097 100.975 81.7493L145.825 70.5996C146.897 70.3331 147.55 69.2481 147.283 68.1762L143.177 51.6596C142.912 50.595 141.84 49.9423 140.773 50.1966L95.8709 60.8973C94.4002 61.2478 93.8402 63.0393 94.7894 64.2161Z"
                fill="#A279FF"
                stroke="#A279FF"
              />
              <path
                d="M63.9751 44.5714L80.9751 54.0121C82.3081 54.7523 83.946 53.7884 83.946 52.2636V3C83.946 1.89543 83.0506 1 81.946 1H64.946C63.8415 1 62.946 1.89543 62.946 3V42.823C62.946 43.5494 63.34 44.2188 63.9751 44.5714Z"
                fill="#A279FF"
                stroke="#A279FF"
              />
            </svg>
          </div>
        </div>
        <div id="_recapt-content">
          <div class="_recapt-header">
            <div class="_recapt-header-left">
              <span class="_recapt-live-dot"></span>
              <span class="_recapt-title">Feedback</span>
            </div>
            <button id="_recapt-close" type="button">&#x2715;</button>
          </div>
          <div class="_recapt-divider"></div>
          <div class="_recapt-session-section">
            <div class="_recapt-session-row">
              <div class="_recapt-session-info">
                <span class="_recapt-label">Session ID</span>
                <span class="_recapt-session-id" id="_recapt-session-id">${sessionId}</span>
              </div>
              <button type="button" class="_recapt-copy-btn" id="_recapt-copy-link">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path>
                  <path d="M15 2H9a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1Z"></path>
                </svg>
                Copy Link
              </button>
            </div>
          </div>
          <div class="_recapt-divider"></div>
          <div class="_recapt-form-section">
            <form id="_recapt-form">
              <textarea placeholder="Enter feedback..."></textarea>
              <button type="submit" class="_recapt-send-btn">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="white"
                  stroke="none"
                >
                  <path
                    d="M3.478 2.404a.75.75 0 0 0-.926.941l2.432 7.905H13.5a.75.75 0 0 1 0 1.5H4.984l-2.432 7.905a.75.75 0 0 0 .926.94 60.519 60.519 0 0 0 18.445-8.986.75.75 0 0 0 0-1.218A60.517 60.517 0 0 0 3.478 2.404Z"
                  ></path>
                </svg>
              </button>
              <span class="_recapt-helper">Press Enter to submit &middot; Comment is timestamped to the session</span>
            </form>
          </div>
        </div>
      </div>
    </div>
  </body>
</html>

`;
};

export const SetupUserCommentsScript = (
  shadow: ShadowRoot,
  sessionUrl: string,
) => {
  const element = shadow.getElementById('_recapt-circle');
  const contentElement = shadow.getElementById('_recapt-content');
  const formElement = shadow.getElementById('_recapt-form');

  if (!element) return;
  if (!contentElement) return;
  if (!formElement) return;
  const textareaElement = formElement.children[0] as HTMLTextAreaElement;
  if (!textareaElement) return;
  const closeButtonElement = shadow.getElementById('_recapt-close');
  if (!closeButtonElement) return;

  const copyButtonElement = shadow.getElementById('_recapt-copy-link');
  if (!copyButtonElement) return;

  copyButtonElement.addEventListener('click', () => {
    navigator.clipboard.writeText(sessionUrl);
  });

  const MAX_TEXTAREA_HEIGHT = 160;

  const autoResizeTextarea = () => {
    textareaElement.style.height = 'auto';
    const scrollHeight = textareaElement.scrollHeight;
    const newHeight = Math.min(scrollHeight, MAX_TEXTAREA_HEIGHT);
    textareaElement.style.height = newHeight + 'px';
    textareaElement.style.overflowY =
      scrollHeight > MAX_TEXTAREA_HEIGHT ? 'auto' : 'hidden';
  };

  const resetTextareaSize = () => {
    textareaElement.style.height = '42px';
    textareaElement.style.overflowY = 'hidden';
  };

  const open = () => {
    contentElement.style.display = 'flex';
    contentElement.style.pointerEvents = 'auto';
    textareaElement.focus();
  };

  const close = () => {
    contentElement.style.display = 'none';
    contentElement.style.pointerEvents = 'none';
  };

  shadow.addEventListener('click', (e) => {
    let element = e.target as HTMLElement;
    while ('parentElement' in element && element.parentElement) {
      if (element.id === '_recapt-user-comments-parent') return;
      element = element.parentElement;
    }
    close();
  });

  element.addEventListener('click', () => {
    open();
  });

  const submitComment = () => {
    const comment = textareaElement.value + '';
    if (comment.trim().length === 0) return;

    textareaElement.value = '';
    resetTextareaSize();
    const event = new CustomEvent('_recapt-comment', { detail: { comment } });
    window.dispatchEvent(event);
    close();
  };

  textareaElement.addEventListener('input', autoResizeTextarea);

  formElement.addEventListener('submit', (e) => {
    e.preventDefault();
    submitComment();
  });

  textareaElement.addEventListener('keydown', (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      e.stopPropagation();
      submitComment();
    }
  });

  closeButtonElement.addEventListener('click', () => {
    close();
  });
};
